module.exports = __webpack_public_path__ + "static/media/display11.c0ec09a6.jpg";